module.exports = __webpack_public_path__ + "static/media/cover-the-essentials-2x.dc655b62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onboard/cover-the-essentials-2x.png
// module id = 1143
// module chunks = 44